import React from 'react';
import { WebUrlData } from '@base-configs';
import { Navigate } from 'react-router-dom';

export function ActivityFeature() {
  return <Navigate to={WebUrlData.activity_activities} replace />;
}
